import {
  RESET_BOOK_RESPONSE,
  RESET_FORM_TYPE,
  SET_TPA_DETAILS,
  SET_APPOINTMENT_DATE_TYPE,
  SET_MOBILE_TYPE,
  SET_EMAIL_TYPE,
  SET_APPOINTMENT_TIME_TYPE,
  SET_IS_MODAL_OPEN_TYPE,
  SET_ERROR_TYPE,
  SET_LANGUAGE_TYPE,
  SET_CALL_MODE_TYPE,
  SET_IS_INSTANT_TYPE,
  SET_VH_SLOTS_TYPE,
  SET_VH_MIN_DATE_TYPE,
  SET_VH_MAX_DATE_TYPE
} from "./types";


export function resetBookMemberDetails() {
  return { type: RESET_BOOK_RESPONSE };
}

//SETTERS//
export function setTpaDetails(data) {
  return {
    type: SET_TPA_DETAILS,
    payload: data,
  };
}

export function setAppointmentDate(data) {
  return {
    type: SET_APPOINTMENT_DATE_TYPE,
    payload: data,
  };
}
export function setMobile(data) {
  return {
    type: SET_MOBILE_TYPE,
    payload: data,
  };
}
export function setEmail(data) {
  return {
    type: SET_EMAIL_TYPE,
    payload: data,
  };
}
export function setAppointmentTime(data) {
  return {
    type: SET_APPOINTMENT_TIME_TYPE,
    payload: data,
  };
}
export function setIsModalOpen(data) {
  return {
    type: SET_IS_MODAL_OPEN_TYPE,
    payload: data,
  };
}

export function setErrors(data) {
  return {
    type: SET_ERROR_TYPE,
    payload: data,
  };
}

export function setLanguage(data){
  return {type: SET_LANGUAGE_TYPE, payload: data}
}

export function setCallMode(data){
  return {type: SET_CALL_MODE_TYPE, payload: data}
}

export function setIsInstant(data){
  return {type: SET_IS_INSTANT_TYPE, payload: data}
}

export function setVhSlots(data){
  return {type: SET_VH_SLOTS_TYPE, payload: data}
}

export function setVhMinDate(data){
  return {type: SET_VH_MIN_DATE_TYPE, payload: data}
}

export function setVhMaxDate(data){
  return {type: SET_VH_MAX_DATE_TYPE, payload: data}
}

export function resetForm(data) {
  return {type: RESET_FORM_TYPE, payload: data };
}
